import React from 'react';
import { Chip } from '@mui/material';
import { Query } from 'system/query/Query';

export interface SelectedQueriesProps {
  selectedQueries: Query[];
  removeSelectedQuery: (queryId: string) => void;
}

export default function SelectedQueries(props: SelectedQueriesProps): JSX.Element {
  return (
    <>
      {props.selectedQueries.map((query, index) => (
        <Chip
          sx={{ ml: 1, mt: 1 }}
          key={query.id || index}
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
          }}
          onDelete={() => {
            if (query.id) {
              props.removeSelectedQuery(query.id);
            }
          }}
          label={query.name}
        />
      ))}
    </>
  );
}